import { EmptyBox } from 'phosphor-icons';
import { interpolateStringWithData } from 'utils';
import { c } from '../../../utils/tailwind-merge';
import { Link } from '../../atoms/Link/Link';
import { UserAssetsCollectionProps } from './UserAssetCollection.types';

const MAX_IMAGES = 4;

export const UserAssetsCollection = ({
  teaserImages,
  link,
  title,
  length,
  isEmpty,
  ratio = 'aspect-[3/2]',
  roundedSize = 'rounded-lg',
  microcopy,
  customFooter,
  className = '',
}: UserAssetsCollectionProps) => {
  const teaserImageClasses = c(
    'w-full bg-center bg-no-repeat bg-cover',
    ratio,
    roundedSize
  );

  const listCountText =
    length === 1 ? microcopy.singleListString : microcopy.otherListString;

  return (
    <Link
      data-test="user-asset-collection"
      href={link}
      className={c('sm:w-1/2 mb-6 w-full px-2 md:w-1/3 lg:w-1/4', className)}
    >
      {isEmpty ? (
        <div
          className={c(
            'flex items-center justify-center py-[18px]',
            ratio,
            roundedSize
          )}
        >
          <EmptyBox size={164} />
        </div>
      ) : (
        <div className="grid grid-cols-2 gap-1 overflow-hidden">
          {teaserImages.slice(0, MAX_IMAGES).map((image) => {
            return (
              <div
                data-test="user-asset-collection-teaser-image"
                className={teaserImageClasses}
                style={{ backgroundImage: `url('${image}')` }}
                key={image}
              ></div>
            );
          })}
          {teaserImages.length < MAX_IMAGES
            ? Array.from<number>({
                length: MAX_IMAGES - teaserImages.length,
              }).map((_, index) => {
                return (
                  <div
                    data-test="user-asset-collection-placeholder"
                    className={c(teaserImageClasses, 'bg-grey-200')}
                    // index is okay to use as a key here since the items will never change order, and there is no other way to differentiate items
                    // eslint-disable-next-line react/no-array-index-key
                    key={index}
                  ></div>
                );
              })
            : null}
        </div>
      )}
      {customFooter ?? (
        <>
          <div className="mt-4 break-words text-md">{title}</div>
          <div className="mt-1 text-sm text-grey-600">
            {interpolateStringWithData(listCountText, {
              number: String(length),
            })}
          </div>
        </>
      )}
    </Link>
  );
};
